// extracted by mini-css-extract-plugin
export var breadcrumbButton = "breadcrumb-list-module--breadcrumb-button--dcd8b";
export var listBreadcrumbs = "breadcrumb-list-module--list-breadcrumbs--9fff2";
export var white = "breadcrumb-list-module--white--d4522";